import { SUPPORT_LANGUAGES } from '../../../common/translation/TranslationConstants';

export const languageToMenuNameMap = {
  [SUPPORT_LANGUAGES.FI]: 'Footer Navigation FI',
  [SUPPORT_LANGUAGES.SV]: 'Footer Navigation SV',
  [SUPPORT_LANGUAGES.EN]: 'Footer Navigation EN',
} as const;
